import styled from 'styled-components';

export const ContainerFlex = styled.div`
    display: flex;
    flex-direction: ${ ({ flexDirection }) => flexDirection };
    flex-wrap: no-wrap;
    height: 100%;
    max-height: 100%;
    min-width: 700px;
    overflow-y: hidden;
    position: relative;
`;

export const PinMessage = styled.div`
    color: ${ ({ theme: { textColor } }) => textColor };
    cursor: pointer;
    font-weight: 400;
    padding: 20px 20px 0px 20px;
`;
